/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientDto } from './PatientDto';
import {
    PatientDtoFromJSON,
    PatientDtoFromJSONTyped,
    PatientDtoToJSON,
    PatientDtoToJSONTyped,
} from './PatientDto';

/**
 * 
 * @export
 * @interface PatientResponseDto
 */
export interface PatientResponseDto {
    /**
     * information patient
     * @type {PatientDto}
     * @memberof PatientResponseDto
     */
    patient: PatientDto;
}

/**
 * Check if a given object implements the PatientResponseDto interface.
 */
export function instanceOfPatientResponseDto(value: object): value is PatientResponseDto {
    if (!('patient' in value) || value['patient'] === undefined) return false;
    return true;
}

export function PatientResponseDtoFromJSON(json: any): PatientResponseDto {
    return PatientResponseDtoFromJSONTyped(json, false);
}

export function PatientResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': PatientDtoFromJSON(json['patient']),
    };
}

export function PatientResponseDtoToJSON(json: any): PatientResponseDto {
    return PatientResponseDtoToJSONTyped(json, false);
}

export function PatientResponseDtoToJSONTyped(value?: PatientResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': PatientDtoToJSON(value['patient']),
    };
}

